import React from 'react';

function Video(props) {
	return (
		<div>
			<div className="video-wrapper">
				<iframe width="100%" height="100%" autostart="false" volume="" player-id="vimeo1574261005285" id="vimeoIframe" src="//player.vimeo.com/video/374669673?player_id=vimeo374669673&amp;title=0&amp;byline=0&amp;portrait=0" frameBorder="0" webkitallowfullscreen="" mozallowfullscreen="" allowFullScreen="true"></iframe>
			</div>
		</div>
	);
}

export default Video;


// WEBPACK FOOTER //
// ./src/components/Video.js